// extracted by mini-css-extract-plugin
export default {"Navigation":"navigation_Navigation__lzZot","Navigation__logo":"navigation_Navigation__logo__zaoTh","Navigation__menu":"navigation_Navigation__menu__-aP8o"};